const TOKEN_KEY = 'authToken';
const USER_KEY = 'userData';

export const getStoredToken = () => {
    return localStorage.getItem(TOKEN_KEY);
};

export const setStoredToken = (token) => {
    localStorage.setItem(TOKEN_KEY, token);
};

export const removeStoredToken = () => {
    localStorage.removeItem(TOKEN_KEY);
};

export const getStoredUser = () => {
    const userData = localStorage.getItem(USER_KEY);
    return userData ? JSON.parse(userData) : null;
};

export const setStoredUser = (user) => {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const removeStoredUser = () => {
    localStorage.removeItem(USER_KEY);
};

export const clearStorage = () => {
    localStorage.clear();
};
